import { useState } from "react";
import { C, S } from "../utils/theme";
import { saveData } from "../utils/data";

export function Modal({ open, onClose, title, children, footer, w = 560 }) {
  if (!open) return null;
  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal(w)}>
        <div style={S.modalHead}>
          <h3 style={{ fontSize: 18, fontWeight: 700, color: C.text, margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, color: C.textMuted, lineHeight: 1 }}>✕</button>
        </div>
        <div style={S.modalBody}>{children}</div>
        {footer && <div style={S.modalFoot}>{footer}</div>}
      </div>
    </div>
  );
}

export function Inp({ label, ...props }) {
  return (
    <div style={S.formGroup}>
      {label && <label style={S.label}>{label}</label>}
      <input style={S.input} {...props} onFocus={e => e.target.style.borderColor=C.navy} onBlur={e => e.target.style.borderColor=C.border} />
    </div>
  );
}

export function Txtarea({ label, rows = 4, ...props }) {
  return (
    <div style={S.formGroup}>
      {label && <label style={S.label}>{label}</label>}
      <textarea rows={rows} style={{ ...S.input, resize: "vertical", fontFamily: "inherit" }} {...props} onFocus={e => e.target.style.borderColor=C.navy} onBlur={e => e.target.style.borderColor=C.border} />
    </div>
  );
}

export function Sel({ label, children, ...props }) {
  return (
    <div style={S.formGroup}>
      {label && <label style={S.label}>{label}</label>}
      <select style={{ ...S.input, appearance: "auto", cursor: "pointer" }} {...props}>{children}</select>
    </div>
  );
}

export function Badge({ type = "gray", children }) { return <span style={S.badge(type)}>{children}</span>; }

export function ProgressBar({ value = 0, color = C.navy }) {
  return <div style={S.progressWrap}><div style={S.progressFill(value, color)} /></div>;
}

export function GlassCard({ children, style = {}, onClick }) {
  const [hov, setHov] = useState(false);
  return (
    <div style={{ ...S.card, ...(hov && onClick ? { borderColor: C.navy, transform: "translateY(-3px)", boxShadow: "0 8px 20px rgba(15,23,42,0.1)" } : {}), ...style, transition: "all 0.25s ease", cursor: onClick ? "pointer" : "default" }}
      onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      {children}
    </div>
  );
}

export function StatCard({ icon, label, value, color, sub }) {
  return (
    <div style={{ ...S.card, padding: "22px 24px", borderTop: `3px solid ${color}`, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -10, right: -10, fontSize: 60, opacity: 0.06 }}>{icon}</div>
      <div style={{ fontSize: 26, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 28, fontWeight: 900, color: C.text, lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: 13, color: C.textMuted, marginTop: 6 }}>{label}</div>
      {sub && <div style={{ fontSize: 11, color: color, marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

export function PageHdr({ title, sub, action }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28 }}>
      <div><h2 style={S.pageTitle}>{title}</h2>{sub && <p style={S.pageSub}>{sub}</p>}</div>
      {action && <div>{action}</div>}
    </div>
  );
}

export function Empty({ icon = "📭", text = "Nothing here yet", sub }) {
  return (
    <div style={S.emptyWrap}>
      <div style={{ fontSize: 52, marginBottom: 14, opacity: 0.4 }}>{icon}</div>
      <div style={{ fontSize: 15, fontWeight: 600, color: C.textMid }}>{text}</div>
      {sub && <div style={{ fontSize: 13, color: C.textMuted, marginTop: 6 }}>{sub}</div>}
    </div>
  );
}

export function LevelBadge({ level }) {
  const map = { general: ["🔵","general","General"], core: ["🟣","core","Core"], specialist: ["🟡","specialist","Specialist"] };
  const [icon,type,label] = map[level] || ["⚪","gray",level];
  return <Badge type={type}>{icon} {label}</Badge>;
}

export function FeesBadge({ status }) {
  const map = { paid: ["✅","paid","Paid"], partial: ["⚠️","partial","Partial"], unpaid: ["❌","unpaid","Unpaid"] };
  const [icon,type,label] = map[status] || ["❓","gray",status];
  return <Badge type={type}>{icon} {label}</Badge>;
}

export function NotifDrawer({ data, setData, userId, onClose }) {
  const notifs = (data.notifications||[]).filter(n=>n.userId===userId).slice().reverse();
  const unread = notifs.filter(n=>!n.read).length;
  const markAll = () => { const upd={...data,notifications:data.notifications.map(n=>n.userId===userId?{...n,read:true}:n)}; setData(upd); saveData(upd); };
  return (
    <div style={{ position:"absolute", right:0, top:52, width:360, background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, boxShadow:"0 20px 50px rgba(15,23,42,0.15)", zIndex:300, overflow:"hidden" }}>
      <div style={{ padding:"16px 20px", borderBottom:`1px solid ${C.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <span style={{ fontWeight:700, fontSize:15, color:C.text }}>Notifications {unread>0&&<Badge type="danger">{unread}</Badge>}</span>
        {unread>0&&<button style={S.btn("ghost","sm")} onClick={markAll}>Mark all read</button>}
      </div>
      <div style={{ maxHeight:380, overflowY:"auto" }}>
        {notifs.length===0 ? <div style={{ padding:28, textAlign:"center", color:C.textMuted, fontSize:13 }}>No notifications</div>
          : notifs.map(n=>(
            <div key={n.id} style={{ padding:"13px 20px", borderBottom:`1px solid ${C.border}`, background:n.read?"transparent":C.navyPale, display:"flex", gap:12 }}>
              <span style={{ fontSize:18, marginTop:1 }}>{n.type==="fees"?"💰":n.type==="exam"?"📋":n.type==="assignment"?"📝":"📢"}</span>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, color:C.textMid, lineHeight:1.5 }}>{n.message}</div>
                <div style={{ fontSize:11, color:C.textMuted, marginTop:3 }}>{n.date}</div>
              </div>
              {!n.read&&<div style={{ width:8, height:8, borderRadius:"50%", background:C.navy, marginTop:5, flexShrink:0 }} />}
            </div>
          ))
        }
      </div>
    </div>
  );
}
